import Navigator from 'app';
import aboutItemview from './views/about_itemview';
export default {
  showAbout: function () {
    var aboutView = new aboutItemview();
    Navigator.vent.trigger("loading:show");
    Navigator.mainRegion.show(aboutView);
    Navigator.vent.trigger("loading:hide");
  }
};